import Timer from "../timer/Timer";
import './LaunchCountdown.css';
function LaunchCountdown({launchDate, handleLaunchTimerExpiry, hasLaunched}) {
  const secondsRemaining = (new Date(launchDate) - new Date())/1000;
  
  if (hasLaunched) {
    return (
      <>
        <p id="launched-message" className="title is-1 has-text-centered">Minting Live!</p>
        <p id="launched-message-long" className="title is-1 has-text-centered">Click one of the buy buttons below to purchase your Holiday Canuckz!</p>
      </>
    )
  }
  return (
    <>
    <LaunchLabel/>
    <Timer 
      duration={secondsRemaining} 
      expireReservation={() => handleLaunchTimerExpiry()}
      timerType="launchCountdown"
    />
    </>
  );
}


function LaunchLabel() {
  return <h1 id="launch-label" className="has-text-centered">Canuckz Holiday Drop:</h1>
};
export default LaunchCountdown;